module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/portfolio.json
// module id = 309
// module chunks = 192094587461937